// extracted by mini-css-extract-plugin
export default {"wrapper":"ColoredClient_wrapper__noCLA","edit_icon":"ColoredClient_edit_icon__cjuf-","content":"ColoredClient_content__DY11K"};